// NgRX
import { createAction, createActionGroup, props } from '@ngrx/store';

// Models
import { Token, Network, Petition} from '@core/models/network.interface';



export const NetworkActions = createActionGroup({
  source: 'Fetch Network',
  events: {
    'load': props<any>(),
    'success': props<{ petition: Petition }>(),
    'error': props<{ petition: Petition }>(),
    'inject token': props<{ token: Token }>()
  },
});
